<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      :class="[`darken-${hover ? 2 : 0}`, `elevation-${hover ? 5 : 5}` ]"
      v-if="document != false"
      :color="cardColor"
      dark
      class="document-card"
      :to="cardAction"
    >
      <v-layout fill-height column ma-0>
        <v-card-actions class="pa-1 pb-0">
          <v-spacer></v-spacer>

          <v-menu
            :style=" { visibility: isOrder ? 'hidden' : 'visible' }"
            bottom
            left
            offset-x
            open-on-hover
            content-class="more-menu"
          >
            <v-btn small slot="activator" icon>
              <div class="v-icon">
                <fa-icon :icon="['far', 'ellipsis-v']" size="sm" />
              </div>
            </v-btn>

            <v-list class="pa-0">
              <v-list-tile v-if="isQuote" :to="cardAction">
                <v-list-tile-title>Continue Quote</v-list-tile-title>
              </v-list-tile>

              <v-list-tile v-if="!isQuote && isNotSent" @click="sendDocument">
                <v-list-tile-title>Send Proposal</v-list-tile-title>
              </v-list-tile>

              <v-list-tile @click="deleteDocument">
                <v-list-tile-title>Delete</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-card-actions>

        <v-card-text class="py-0">
          <div class="document-card__number" v-html="document_number"></div>

          <router-link :to="cardAction" class="document-card__title">
            <div class="v-icon v-icon--left">
              <fa-icon :icon="['far', cardTitleIcon]" fixed-width size="sm" />
            </div>

            <span v-html="document_name"></span>
          </router-link>

          <div class="document-card__status">
            <div class="v-icon v-icon--left">
              <fa-layers class="fa-sm fa-fw">
                <fa-icon :icon="iconBg" :class="iconBgColor" />
                <fa-icon :icon="icon" transform="shrink-7 down-1.1" :class="iconColor" />
              </fa-layers>
            </div>

            <span>{{document.status}}</span>
          </div>
        </v-card-text>

        <!-- <v-card-actions class="pa-3">
					<v-btn small flat outline dark :to="cardAction">{{cardActionText}}</v-btn>
        </v-card-actions>-->

        <v-spacer></v-spacer>

        <v-card-actions class="px-3 py-2">
          <div class="v-icon v-icon--left">
            <fa-layers>
              <fa-icon :icon="['far', 'calendar']" />
              <fa-layers-text
                :value="dayOfMonth"
                transform="shrink-9 down-2"
                class="font-weight-black"
              ></fa-layers-text>
            </fa-layers>
          </div>
          {{ document.proposal_date | moment("MMM D YYYY") }}
          <v-spacer></v-spacer>
          <div class="v-icon v-icon--left">
            <fa-icon :icon="['far', 'sack-dollar']" fixed-width />
          </div>
          {{ document.total | currency}}
        </v-card-actions>
      </v-layout>
      <!-- <code>{{document}}</code> -->
    </v-card>
  </v-hover>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
var { documents } = require("@root/mixins");

export default {
  data: () => ({
    items: [{ title: "Continue Quote", quoteOnly: true }, { title: "Delete" }]
  }),

  mixins: [documents],

  props: {
    document: {
      default: false
    }
  },

  computed: {
    ...mapGetters(["searchQuery"]),

    searchRegex() {
      return (flags = "gi") => new RegExp(this.searchQuery, flags);
    },

    dayOfMonth() {
      return moment(this.document.proposal_date).date();
    },

    isQuote() {
      return this.document.type === "Quote";
    },

    isProposal() {
      return this.document.type === "Proposal";
    },

    isOrder() {
      return this.document.type === "Order";
    },

    isNotSent() {
      return this.document.status === "Not Sent";
    },

    iconColor() {
      return this.isQuote || this.isNotSent
        ? "accent--text darken-3"
        : "white--text";
    },

    icon() {
      return !this.isQuote && !this.isNotSent ? "check" : "exclamation";
    },

    iconBgColor() {
      return !this.isQuote && !this.isNotSent
        ? "success--text"
        : "yellow--text";
    },

    iconBg() {
      return !this.isQuote && !this.isNotSent ? "circle" : "triangle";
    },

    cardColor() {
      return !this.isQuote ? "secondary" : "accent";
    },

    cardActionText() {
      return this.isQuote ? "Continue" : "View";
    },

    cardAction() {
      return this.getBuilderUrl(this.document, false, {
        category: "electric-chain-hoist"
      });
    },

    cardTitleIcon() {
      return !this.isQuote ? "file-alt" : "pencil-alt";
    },

    document_number() {
      let number = this.document.number;

      if (this.searchQuery) {
        return this.highlight(number, "i");
      }

      return number;
    },

    document_name() {
      let document_name = this.document.name;

      if (this.searchQuery) {
        return this.highlight(document_name);
      }

      return document_name;
    }
  },

  methods: {
    ...mapActions("documents", {
      DELETE_DOCUMENT: "deleteDocument",
      SEND_DOCUMENT: "sendDocument"
    }),

    highlight(text, flags) {
      return (text = text.replace(this.searchRegex(flags), found => {
        return `<span class="search-highlight">${found}</span>`;
      }));
    },

    deleteDocument() {
      this.DELETE_DOCUMENT(this.document);
    },

    sendDocument() {
      this.SEND_DOCUMENT(this.document);
    }
  }
};
</script>
